module.exports = __webpack_public_path__ + "static/play-a90997bf46a9fd235fa5c8f6cba41a35.png";